import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section
      id="home"
      style={{
        background: 'var(--gradient-hero)',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        textAlign: 'center',
        padding: '7rem 1.5rem 3rem'
      }}
    >
      <div className="container" style={{ maxWidth: '900px' }}>
        <div style={{ marginBottom: '1.5rem' }}>
          <h1 className="heading-1" style={{ lineHeight: '1.1' }}>
            Empowering Businesses with Intelligent Digital Solutions
          </h1>
        </div>
        
        <div style={{ marginBottom: '2rem' }}>
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
            We build your brand's online success through AI-driven marketing and web excellence.
          </p>
        </div>
        
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/contact" className="btn-primary" style={{ gap: '0.5rem' }}>
            Get Started
            <ArrowRight size={20} />
          </Link>
          <Link to="/services" className="btn-secondary" style={{ gap: '0.5rem' }}>
            View Services
          </Link>
        </div>

        {/* Trust Indicators */}
        <div style={{ marginTop: '4rem', display: 'flex', gap: '3rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          <div>
            <div style={{ fontSize: '2rem', fontWeight: '700', color: 'var(--accent-text)' }}>10+</div>
            <div className="body-small" style={{ marginTop: '0.25rem' }}>Clients Served</div>
          </div>
          <div>
            <div style={{ fontSize: '2rem', fontWeight: '700', color: 'var(--accent-text)' }}>100%</div>
            <div className="body-small" style={{ marginTop: '0.25rem' }}>Client Satisfaction</div>
          </div>
          <div>
            <div style={{ fontSize: '2rem', fontWeight: '700', color: 'var(--accent-text)' }}>24/7</div>
            <div className="body-small" style={{ marginTop: '0.25rem' }}>Support Available</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;